<div class="principal-section">
    <div class="img-principal3">
        <div class="wraper">
            <div class="data">
                <div class="description">
                    <p>
                        Você quer experimentar FAD®?<span><br>é fácil, crie uma conta e...</span>
                    </p>
                </div>
                <div class="title">
                    <p>Receba<br>
                        <span>3 assinaturas GRÁTIS</span><br></p>
                </div>
                <div class="actions red" (click)="freeTest()">
                    <div id="pop_registrarse_promo" class="preview">
                        <p>
                            CRIE SUA CONTA AGORA!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="side imagen-prin">
        <img src="assets/images/firma-prin3.png" alt="Prueba gratis">
        <img (click)="close()" id="pop_cerrar_promo" class="close" src="assets/images/icon_cross.png" alt="Cerrar">
    </div>
</div>

<div class="movil-section">
    <div class="side imagen-prin">
        <img src="assets/images/m/mprueba.png" alt="Prueba gratis">
    </div>
    <div class="wraper">
        <img id="pop_cerrar_promo_movil" (click)="close()" class="close" src="assets/images/icon_cross_mov.png"
             alt="Cerrar">
        <div class="data">
            <div class="description">
                <p>
                    Você quer experimentar FAD®?<span><br>é fácil, crie uma conta e...</span>
                </p>
            </div>
            <div class="title">
                <p>Receba<br>
                    <span>3 assinaturas GRÁTIS</span><br></p>
            </div>
            <div class="actions red" (click)="freeTest()">
                <div id="pop_registrarse_promo_movil" class="preview">
                    <p>
                        CRIE SUA CONTA AGORA!
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
